<template>
	<div class="v-tags" :class="classes">
		<ul v-if="dataTags.length">
			<li class="v-tags__tag" v-for="(tag, index) in dataTags" :key="index">
				<span class="v-tags__tag__label">{{ tagLabel(tag) }}</span>
				<button type="button" class="icon icon--x" @click.prevent="deleteTag(index)">Delete</button>
			</li>
		</ul>
		<input
			type="hidden" v-if="tags.length && fieldName" v-for="(tag, index) in tags" :key="index" :name="name(index)"
			:value="value(tag)">
		<v-typeahead
			:datasets="datasets"
			:excluded="tags"
			v-on:focused="toggleFocused"
			v-on:blured="toggleFocused"
			v-on:autocomplete-failed="newTag"
			v-on:autocompleted="addTag"
			ref="typeahead"/>
	</div>
</template>
<script>
export default {
	data() {
		return {
			focused: false,
			dataTags: [],
		};
	},

	watch: {
		tags(tags) {
			this.dataTags = tags;
		},
	},

	props: {
		tags: {
			type: Array,
			default() {
				return [];
			}
		},
		useLocalTags: true,
		datasets: Array,
		options: Array,
		allowDuplicates: {
			type: Boolean,
			default() {
				return false;
			},
		},
		vertical: {
			type: Boolean,
			default() {
				return false;
			},
		},
		tagLabel: {
			type: Function,
			default(option) {
				if (typeof option === "object") {
					if (!option.hasOwnProperty(this.label)) {
						return console.warn(
							`[vue-select warn]: Label key "option.${this.label}" does not` +
							` exist in options object ${JSON.stringify(option)}.\n` +
							"https://vue-select.org/api/props.html#getoptionlabel"
						);
					}

					return option[this.label];
				}

				return option;
			}
		},
		createTags: false,
		fieldName: {
			type: String,
			default() {
				return null;
			},
		},
	},

	computed: {
		classes() {
			return {
				"v-tags--vertical": this.vertical,
				"v-tags--focused": this.focused,
			};
		},
	},

	methods: {
		toggleFocused() {
			this.focused = !this.focused;

			if (!this.focused) {
				this.$refs.typeahead.setSearch("");
			}
		},
		deleteLastTag(e, search) {
			if (8 != e.keyCode || "" != search || !this.tags.length) {
				return;
			}

			this.deleteTag(this.tags.lastIndexOf());
		},
		newTag(tag, typeahead, e) {
			if (this.$refs.typeahead) {
				this.$refs.typeahead.clear();
			}

			if (!this.createTags) {
				this.$emit("new-tag-attempted", tag, this, e);
				return;
			}

			this.tags.push(tag);
			this.$emit("new-tag-added", this.tags, e);
		},
		addTag(tag, e) {
			e.stopPropagation();
			if (this.$refs.typeahead) {
				this.$refs.typeahead.clear();
			}

			if (!this.allowDuplicates && this.tags.indexOf(tag) >= 0) {
				return;
			}

			this.tags.push(tag);
			this.$emit("tag-added", tag, this.tags);
		},
		deleteTag(index) {
			var tag = this.tags[index];
			this.tags.splice(index, 1);
			this.$emit("tag-deleted", index, tag, this.tags);
		},
		name(index) {
			return this.fieldName + "[" + index + "]";
		},
		value(tag) {
			return tag.identity ?
				tag.identity :
				tag.display;
		},
	},
};
</script>
